import { useEffect, useState } from 'react'
import { api } from '@carrent/api'
import { Icon } from '@carrent/ui'
import { SETTINGS_SCHEMA } from './registry'

/** Настройки одного гаджета: период, горизонт, выбранный показатель. */
export function WidgetSettingsModal({ widget, spec, onSave, onClose }) {
  const [values, setValues] = useState(widget.settings || {})
  const [regions, setRegions] = useState([])
  const [regionsError, setRegionsError] = useState(false)

  const fields = SETTINGS_SCHEMA[widget.type] || []
  // Срез по региону умеют не все гаджеты: у тикетов, например,
  // привязки к региону нет вовсе. Признак приходит с каталогом.
  const regionAware = Boolean(spec?.region_aware)

  useEffect(() => {
    if (!regionAware) return undefined
    let cancelled = false
    api
      .get('/regions')
      .then(({ data }) => !cancelled && setRegions(data.data || []))
      .catch(() => !cancelled && setRegionsError(true))
    return () => {
      cancelled = true
    }
  }, [regionAware])

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true"
      aria-label={`Настройки: ${spec?.title || widget.type}`}>
      <div className="modal">
        <header className="modal__head">
          <h2 className="modal__title">{spec?.title || widget.type}</h2>
          <button type="button" className="modal__close" onClick={onClose} aria-label="Закрыть">
            <Icon name="close" size={20} />
          </button>
        </header>

        <div className="modal__body">
          {fields.map((f) => (
            <label key={f.key} className="field">
              <span className="field__label">{f.label}</span>
              <select
                className="input"
                value={values[f.key] ?? f.options[0].value}
                onChange={(e) => {
                  const raw = e.target.value
                  const opt = f.options.find((o) => String(o.value) === raw)
                  setValues((v) => ({ ...v, [f.key]: opt ? opt.value : raw }))
                }}
              >
                {f.options.map((o) => (
                  <option key={o.value} value={o.value}>
                    {o.label}
                  </option>
                ))}
              </select>
            </label>
          ))}

          {regionAware && (
            <label className="field">
              <span className="field__label">Регион</span>
              {regionsError ? (
                <span className="field__hint field__hint--warn">
                  Список регионов не загрузился — гаджет продолжит показывать
                  весь парк.
                </span>
              ) : (
                <select
                  className="input"
                  value={values.region_id ?? 'all'}
                  onChange={(e) => {
                    const raw = e.target.value
                    setValues((v) => ({
                      ...v,
                      region_id: raw === 'all' ? null : Number(raw),
                    }))
                  }}
                >
                  <option value="all">Весь парк</option>
                  {regions.map((r) => (
                    <option key={r.id} value={r.id}>
                      {r.name}
                    </option>
                  ))}
                </select>
              )}
            </label>
          )}
        </div>

        <footer className="modal__foot">
          <button type="button" className="btn btn--ghost" onClick={onClose}>
            Отмена
          </button>
          <button type="button" className="btn btn--primary" onClick={() => onSave(values)}>
            Сохранить
          </button>
        </footer>
      </div>
    </div>
  )
}
